var path = '/pages/guestlists/views/pages/guestlists/overview.tpl.html';
var html = "<div class=\"content-box\" ng-if=\"vm.loading\">\n    <al-loader size=\"medium\"></al-loader>\n</div>\n<al-guestlist-dashboard\n        ng-if=\"!vm.loading\"\n        guestlist=\"vm.guestlist\"></al-guestlist-dashboard>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/views/pages/guestlists/overview.tpl.html
// module id = 2266
// module chunks = 1